export function validateCumulativeFileSize(files: File[], maxMB: number) {
  let size = 0;
  for (let i = 0; i < files.length; i += 1) {
    const file = files[i];
    if (file) {
      size += file.size;
    }
  }

  const maxBytes = maxMB * 1024 * 1024;

  return size <= maxBytes;
}

export function dataURIToBuffer(uri: string) {
  const parts = uri.split(',');
  const base64 = parts[1];
  const binaryStr = atob(base64);
  const len = binaryStr.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i += 1) {
    bytes[i] = binaryStr.charCodeAt(i);
  }
  return bytes;
}

export function getDataURIMimeType(uri: string) {
  return uri.split(',')[0].split(':')[1].split(';')[0];
}

export function dataURIToFile(uri: string, name: string, lastModified: number) {
  const buffer = dataURIToBuffer(uri);
  const type = getDataURIMimeType(uri);

  return new File([buffer], name, { type, lastModified });
}

export function fileToDataURI(file: File) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.addEventListener(
      'load',
      () => {
        resolve(reader.result);
      },
      false
    );

    reader.addEventListener(
      'error',
      (err) => {
        reject(err);
      },
      false
    );

    reader.readAsDataURL(file);
  });
}
